import { render, staticRenderFns } from "./course-container.vue?vue&type=template&id=38ba58e8&scoped=true&"
import script from "./course-container.vue?vue&type=script&lang=js&"
export * from "./course-container.vue?vue&type=script&lang=js&"
import style0 from "./course-container.vue?vue&type=style&index=0&id=38ba58e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ba58e8",
  null
  
)

export default component.exports